<script>

import Icon from "./Icon.svelte"

export let action = () => {};
export let juicy = false
export let stretch = false
export let clear = false
export let align = "center"
export let icon = ""
export let iconOnly = false
export let iconHeight = "24px"
export let href = null
export let newTab = true

</script>

<a href={href} target={ (href !== null && newTab) ? "_blank" : null } class:iconOnly={iconOnly} class={align} class:clear={clear} class:stretch={stretch} class:juicy={juicy} on:click="{action}">

    {#if icon != ""}
        <Icon color={juicy ? '#75FFF1' : '#A9B2C0'} name={icon} height={iconHeight} margin="0px {iconOnly ? '0px' : '10px'} 0px 0px"> </Icon>
    {/if}
    

    <slot></slot>

</a>


<style>

a {
    background-color: var(--secondary-button-bg-color);
    border-radius: 10px;
    border: none;
    color: var(--text-color);
    padding: 10px 20px;
    transition: all .15s ease-in-out;
    align-self: flex-start;
    margin: 0px;
    border: 1px solid rgba(255,255,255,0.1)
}

a {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

a.left {
    justify-content: flex-start;
}

a.center {
    justify-content: center;
}

a.right {
    justify-content: flex-end;
}

a.edges {
    justify-content: space-between;
}

a:hover {
    opacity: 0.8;
    transform: scale(0.98);
}

a:active {
    background-color: var(--secondary-button-bg-color);
    opacity: 0.7;
    transform: scale(0.92);
}

.stretch:active, a:hover {
    transform: scale(1.0);
    opacity: 0.7;
    text-decoration: none;
}

.juicy {
    color: var(--primary-color);
    background-color: var(--primary-button-bg-color);
}

.juicy:active {
    background-color: var(--primary-button-bg-color);
}

.stretch {
    width: 100%;
}

.iconOnly {
    padding: 10px;
}


.clear, .clear:active {
    background-color: rgba(0,0,0,0);
    padding: 7px 0px;
    border: 1px solid rgba(255,255,255,0)
}




</style>